<div class="container">
  <h1 class="mt120 ml-3">The Bible’s Ministry Mandate</h1>
</div>

<div class="mainContnet">
  <div class="container">
    <div class="videoPart">
      <div class="embed-responsive embed-responsive-21by9"> 
        <!-- <iframe class="embed-responsive-item" src="https://drive.google.com/file/d/1HtOs9WDmt5WbFU_3CdZH8f5CwWwySjrX/preview" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe> -->
        <video controls>  
          <source src="../../../assets/video/seminar-session/session-1.mp4" type="video/mp4">   
        </video>
      </div>
    </div>
    <p class="mt-5 ml-3">Did you complete watching the video?</p>
    <button
      type="button"
      class="btn btnPrimary btnDiscipled"
      data-toggle="modal"
      data-target="#exampleModalLong"
    >
      Yes
    </button>
  </div>
</div>

<div
  class="modal fade"
  id="exampleModalLong"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLongTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header border-0 py-0 pt-0">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>
          Thanks for watching. Now you can see why we so desire to help you make
          disciples in your church
        </p>
        <button
          type="button"
          class="btn btnPrimary btnDiscipled"
          routerLink="/index"
          data-dismiss="modal"
          aria-label="Close"
        >
          Back to home
        </button>
      </div>
    </div>
  </div>
</div>
